import path from 'path';


function tryRequireLocalConfig() {
	try {
		// eslint-disable-next-line global-require, import/no-unresolved
		return require('./config.local').default || {};
	} catch (e) {
		return {};
	}
}


const rootDir = path.dirname(path.dirname(__dirname));

const config = Object.assign({}, {
	rootDir,
	jsDir: path.resolve(rootDir, 'js'),
	publicDir: path.resolve(rootDir, 'www'),
	entryDirName: 'pages',
	outputDirName: 'assets',
	commonsFileName: 'commons.js',
	basePath: '/www',
	hmr: '__webpack_hmr',
	devServerHost: '127.0.0.1',
	devServerPort: 8080,
}, tryRequireLocalConfig());


export default config;



// WEBPACK FOOTER //
// ./js/webpack/config.js